import React from "react";
import { Apple, Play } from "lucide-react";
import { STORE_URLS } from "@/data/content";

export const StoreButtons = ({ className = "" }) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <a
        href={STORE_URLS.googlePlay}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="google-play-button"
        aria-label="Get AlphaPulse on Google Play"
        className="group flex items-center gap-3 bg-vitality text-black px-5 py-3 rounded-xl hover:bg-vitality-dim transition-colors duration-300"
      >
        <Play className="w-7 h-7 fill-current" strokeWidth={1.5} />
        <span className="text-left leading-none">
          <span className="block text-[10px] uppercase tracking-widest opacity-80">Get it on</span>
          <span className="block font-heading text-xl font-bold tracking-tight">Google Play</span>
        </span>
      </a>
      <a
        href={STORE_URLS.appStore}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="app-store-button"
        aria-label="Download AlphaPulse on the App Store"
        className="group flex items-center gap-3 bg-transparent border border-white/20 text-white px-5 py-3 rounded-xl hover:border-vitality hover:text-vitality transition-colors duration-300"
      >
        <Apple className="w-7 h-7" strokeWidth={1.5} />
        <span className="text-left leading-none">
          <span className="block text-[10px] uppercase tracking-widest opacity-70">Download on the</span>
          <span className="block font-heading text-xl font-bold tracking-tight">App Store</span>
        </span>
      </a>
    </div>
  );
};
